package ru.it_mozaika.sender.js.application.frames.files

import js.core.JsLong
import org.khronos.webgl.ArrayBuffer

data class FileDto(
    val filenameWithExtension: String,
    val size: JsLong,
    val webglArrayBuffer: ArrayBuffer,
    val contentTypeString: String,
)
